'use client'

import { useContext } from 'react'

import { Dialog, Text } from '@vinted/web-ui'

import { GetShippingLabelContext } from '@marketplace-web/shipping-services-provider/shipping-services-provider-feature'

type Props = {
  isOpen: boolean
  onGoBack: () => void
  onSuccess: () => void
}

const DropOffTypeConfirmationModal = ({ isOpen, onGoBack, onSuccess }: Props) => {
  const {
    state: {
      dropOffTypeSelection: { selectedDropOffTypeKey },
      labelOptions: { labelOptions },
    },
  } = useContext(GetShippingLabelContext)

  if (!labelOptions?.dropOffTypes?.length) return null

  const selectedDropOffType = labelOptions?.dropOffTypes?.find(
    dropOffTypes => dropOffTypes.key === selectedDropOffTypeKey,
  )

  const titeText = selectedDropOffType?.dropOffTypeMeta.confirmTitle
  const messageText = selectedDropOffType?.dropOffTypeMeta.confirmMessage
  const confirmSelectionText = selectedDropOffType?.dropOffTypeMeta.confirmSelectionTitle
  const cancelSelectionText = selectedDropOffType?.dropOffTypeMeta.cancelSelectionTitle

  return (
    <Dialog
      show={isOpen}
      title={<Text as="h1" type="heading" text={titeText} width="parent" alignment="center" />}
      body={<Text as="span" html text={messageText} />}
      actions={[
        {
          text: confirmSelectionText,
          style: Dialog.ActionStyling.Filled,
          callback: onSuccess,
          testId: 'drop-off-type-confirmation-modal-confirm-button',
        },
        {
          text: cancelSelectionText,
          style: Dialog.ActionStyling.Flat,
          callback: onGoBack,
          testId: 'drop-off-type-confirmation-modal-cancel-button',
        },
      ]}
    />
  )
}

export default DropOffTypeConfirmationModal
